import { useQuery } from 'react-query';
import axios from 'api/axiosInstance';

interface Patient {
  id: number;
  birthDate: string | null;
  gender: string;
  pregnancyStatus: boolean;
  diseases: string;
  allergies: string;
  consultationNotes: string | null;
  memo: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  userId: string;
  lastAiReviewAt: string | null;
  aiReviewCnt: number;
}

interface UseDeletedPatientsParams {
  page?: number;
  limit?: number;
}

export const useDeletedPatients = ({ page = 1, limit = 10 }: UseDeletedPatientsParams = {}) => {
  const offset = (page - 1) * limit;

  return useQuery({
    queryKey: ['deletedPatients', page, limit],
    queryFn: async () => {
      const response = await axios.get<{ error: number; data: Patient[]; message: string }>('/api/v1/patients', {
        params: {
          onlyDeleted: true,
          limit,
          offset,
        },
      });
      return response.data.data; // response.data.data로 실제 배열 반환
    },
    staleTime: 5 * 60 * 1000, // 5분
    keepPreviousData: true, // 페이지 전환 시 이전 데이터 유지
  });
};